// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18oP3","colBig":"styles_colBig__3TzkS","colSmall":"styles_colSmall__1qL4R"};